import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Listing } from "../../types";
import { markListingAsAvailable } from "../../api";

export default function useMarkListingAsAvailable() {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    AxiosResponse<Listing>,
    { response?: { data?: { message?: string } } },
    string
  >({
    mutationFn: (uid: string) => markListingAsAvailable(uid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listings"] });
    },
  });

  return mutation;
}
